module.exports = __webpack_public_path__ + "static/jobs-0d498fff1e50836219da6677d78f0c93.svg";